"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
var _styles = require("./styles");
var _formatGraphPrice = require("../../utils/formatGraphPrice");
var _CustomTooltip = _interopRequireDefault(require("../../shared/recharts/CustomTooltip"));
var _CustomLegend = require("../../shared/recharts/CustomLegend");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SimpleBarChart = ({
  height = '350px',
  width = 'auto',
  data = [],
  bars,
  xAxisDataKey,
  yAxisDataKey,
  xAxisLine = false,
  yAxisLine = false,
  tickLineX = false,
  tickLineY = false,
  legendHAlign = 'left',
  legendVAlign = 'bottom',
  margin,
  legendPadding,
  layout = 'horizontal',
  defaultFormatter = false,
  tickFormatter,
  minTickGapX,
  minTickGapY,
  allowDecimals = true,
  ...rest
}) => {
  const getTickFormatter = () => {
    if (defaultFormatter && !tickFormatter) return undefined;
    if (tickFormatter) return tickFormatter;
    return _formatGraphPrice.formatAxisPrice;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BarChartContainer, {
    width: width && width,
    height: height && height,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.ResponsiveContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.BarChart, {
        data: data && data,
        margin: margin ? margin : {
          top: 0,
          right: 0,
          left: 0,
          bottom: 0
        },
        barGap: "0%",
        layout: layout && layout,
        ...rest,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.CartesianGrid, {
          strokeDasharray: "0",
          vertical: false
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.XAxis, {
          dataKey: xAxisDataKey && xAxisDataKey,
          axisLine: xAxisLine && xAxisLine,
          tickLine: tickLineX && tickLineX,
          type: layout === 'vertical' ? 'number' : 'category',
          tickMargin: 5,
          minTickGap: minTickGapX,
          allowDecimals: allowDecimals,
          tickFormatter: getTickFormatter()
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.YAxis, {
          dataKey: yAxisDataKey && yAxisDataKey,
          axisLine: yAxisLine && yAxisLine,
          tickLine: tickLineY && tickLineY,
          type: layout === 'vertical' ? 'category' : 'number',
          minTickGap: minTickGapY,
          allowDecimals: allowDecimals,
          tickFormatter: getTickFormatter()
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Tooltip, {
          content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomTooltip.default, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Legend, {
          verticalAlign: legendVAlign && legendVAlign,
          align: legendHAlign && legendHAlign,
          content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomLegend.CustomLegend, {}),
          wrapperStyle: {
            paddingLeft: legendPadding?.left ? legendPadding.left : '55px',
            paddingTop: legendPadding?.top ? legendPadding.top : '10px',
            paddingBottom: legendPadding?.bottom ? legendPadding.bottom : '0',
            paddingRight: legendPadding?.right ? legendPadding.right : '0'
          }
        }), bars?.length && bars.map(bar => {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Bar, {
            dataKey: bar.dataKey,
            fill: bar.fill,
            name: bar.name,
            maxBarSize: 50
          }, bar.name);
        })]
      })
    })
  });
};
var _default = exports.default = SimpleBarChart;